/**
 * EN locale strings.
 * Auto-generated from the previous translations.js – safe to hand-edit.
 * Mirror the EN tree shape; any missing key falls back through
 * LOCALIZED_FALLBACK_ORDER in src/config/languages.js.
 */
const en = {
  nav: {
    home: "Home",
    pooja: "Poojas",
    store: "Store",
    temple: "Kshetras",
    astrology: "Astrology",
    liveTv: "Live TV",
    nri: "NRI",
    blogs: "Blogs",
    gallery: "Gallery",
    mobileApp: "Mobile App",
    upcoming: "Upcoming",
    past: "Poojas Performed",
    aboutUs: "About",
    contactUs: "Contact",
    search: "Search...",
    voiceSearch: "Voice search",
    listeningOrType: "Listening... or type to search",
    daiv: "Daiv",
    daivBharathi: "Daiv Bharathi",
    signIn: "Sign In",
    profileTab: "Profile",
    mobileBottomNavAria: "Primary navigation",
    mobileDrawerTitle: "Menu",
    mobileDrawerAria: "All pages and links",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    selectLanguage: "Select language",
    bookAPooja: "Book Pooja",
  },
  nri: {
    badge: "Global Devotee Services",
    titleLine1: "Connecting Diaspora with",
    titleLine2: "Sacred India",
    description: "Authentic Indian rituals performed in your name, streamed live to your timezone, with global prasadam delivery.",
    featureLiveTitle: "Live Streaming",
    featureLiveDesc: "High-quality live feed of your specific ritual so you can participate virtually from any timezone.",
    featurePrasadamTitle: "Global Prasadam",
    featurePrasadamDesc: "International shipping of sacred prasadam and yantras directly from the Kshetra to your doorstep.",
    featureTimezoneTitle: "Timezone Aware",
    featureTimezoneDesc: "We schedule consultations and specific ritual viewings keeping your local time in mind.",
    featuresSectionSrTitle: "Services for global devotees",
    packagesTitle: "Premium NRI Packages",
    packagePopular: "Most Popular",
    packageAnnualTitle: "Annual Temple Connect",
    packageAnnualTagline: "Stay connected to your roots all year round.",
    packageAnnualF1: "Monthly Archana at selected Kshetra",
    packageAnnualF2: "Birthday & Anniversary special poojas",
    packageAnnualF3: "Quarterly Prasadam international delivery",
    packageAnnualF4: "Priority WhatsApp Concierge",
    packageAnnualF5: "Astrology consultation (2 per year)",
    packageAnnualCta: "Subscribe Now",
    packagePitruTitle: "Ancestral Heritage (Pitru)",
    packagePitruTagline: "Complete annual rituals for your ancestors.",
    packagePitruF1: "Annual Shradh at Gaya or Varanasi",
    packagePitruF2: "Mahalaya Amavasya special tarpanam",
    packagePitruF3: "Live video feed with translation",
    packagePitruF4: "Dedicated Acharya for your family",
    packagePitruF5: "Recording of all rituals",
    packagePitruCta: "Book Heritage Package",
    supportCardTitle: "Dedicated Support for Global Devotees",
    supportCardDesc: "Our expert team assists you via WhatsApp or Email to choose the right pooja, gather details for your sankalpa, and ensure a seamless spiritual experience across borders.",
    supportCtaConcierge: "Contact Concierge",
    supportCtaBrowse: "Browse Poojas",
  },
  astrology: {
    kundaliAppEyebrow: "Daiv Bharathi App",
    kundaliAppTitle: "Get Your Free Kundali on Mobile",
    kundaliAppDesc: "Download our app to generate accurate Vedic Kundali, access detailed reports, and get personalized insights anytime.",
    kundaliAppFeature1: "Instant Vedic birth chart",
    kundaliAppFeature2: "Detailed dosha & yoga reports",
    kundaliAppFeature3: "Personalised daily guidance",
    kundaliCtaAppStore: "Download on App Store",
    kundaliCtaPlayStore: "Get it on Google Play",
    heroTitle: "Your Cosmic Guide",
    heroDesc: "Ancient Vedic wisdom meets modern AI technology to guide your spiritual journey.",
    heroImgAlt: "Vedic astrology consultation",
    tabsAria: "Astrology sections",
    tabHoroscope: "Daily Horoscope",
    tabPanchang: "Panchang & Muhurat",
    tabKundali: "Kundali",
    dailyRashiTitle: "Daily Rashi Phalam",
    dailyRashiSubtitle: "Vedic Jyotish readings for all twelve Rashis",
    panchangLoadError: "Unable to load Panchang data.",
    dayRulerNoteLabel: "DAY RULER NOTE",
    favourableBadge: "✓ Favourable",
    dashEmDash: "—",
    loadingPanchang: "Loading Panchang…",
    moonrise: "Moonrise",
    panchaAngaHeading: "Pancha Anga — Five Sacred Elements",
    muhuratsTimingsHeading: "Today's Muhurats & Timings",
    muhuratByActivityHeading: "Muhurat by Activity",
    muhuratActivityNoteLead: "Activities marked",
    muhuratActivityNoteFav: "✓ Favourable Today",
    muhuratActivityNoteTrail: "align with today's Nakshatra and Vara.",
    tableActivity: "Activity",
    tableBestDays: "Best Days",
    tableBestNakshatras: "Best Nakshatras",
    tableToday: "Today",
    lifeAreasToday: "LIFE AREAS TODAY",
    luckyNumberShort: "Lucky No.",
    colourLabel: "Colour",
    vedicRemedyForToday: "VEDIC REMEDY FOR TODAY",
    personalisedJyotishCta: "Get a personalised Jyotish reading from Guruji →",
    bookPopupTitle: "Personalised Jyotish with Guruji",
    bookPopupDesc: "Book a one-to-one Vedic consultation for your kundali, dosha remedies, and life-path guidance.",
    bookPopupDismiss: "Continue browsing",
  },
  rashi: {
    eyebrow: "VEDIC JYOTISHA",
    title: "Daily Rashi Phalam",
    subtitle: "Today's Vedic cosmic guidance for all twelve Rashis.",
    selectYourRashi: "SELECT YOUR RASHI",
    loadingHoroscope: "Loading horoscope…",
    selectRashiPrompt: "Select a Rashi to view your reading.",
    fullReading: "Full reading →",
    todayCosmicReading: "TODAY'S COSMIC READING",
    vedicRemedy: "Vedic Remedy",
    readMoreLink: "Read full Jyotish reading — Career, Health, Spiritual & more →",
    todaysPanchang: "TODAY'S PANCHANG",
    sunrise: "Sunrise",
    sunset: "Sunset",
    varaLabel: "Vara",
    auspiciousMuhurta: "AUSPICIOUS MUHURTA",
    avoidRahuKalam: "AVOID — RAHU KALAM",
    fullJyotishCta: "Full Jyotishya Forecast & Kundali",
    ruledByLead: "Ruled by",
    todayWord: "TODAY",
    signs: {
      ARIES: "Aries",
      TAURUS: "Taurus",
      GEMINI: "Gemini",
      CANCER: "Cancer",
      LEO: "Leo",
      VIRGO: "Virgo",
      LIBRA: "Libra",
      SCORPIO: "Scorpio",
      SAGITTARIUS: "Sagittarius",
      CAPRICORN: "Capricorn",
      AQUARIUS: "Aquarius",
      PISCES: "Pisces",
    },
    secondary: {
      ARIES: "मेष",
      TAURUS: "वृषभ",
      GEMINI: "मिथुन",
      CANCER: "कर्क",
      LEO: "सिंह",
      VIRGO: "कन्या",
      LIBRA: "तुला",
      SCORPIO: "वृश्चिक",
      SAGITTARIUS: "धनु",
      CAPRICORN: "मकर",
      AQUARIUS: "कुम्भ",
      PISCES: "मीन",
    },
  },
  whatsapp: {
    title: "Get Daily Panchang on WhatsApp",
    desc: "Join 2,00,000+ devotees receiving daily spiritual guidance, festival alerts, and pooja reminders — completely free.",
    descAstrology: "Join 2,00,000+ devotees receiving daily Panchang, festival alerts, and auspicious timings — completely free.",
    placeholderPhone: "+91 98765 43210",
    subscribeFree: "Subscribe Free",
    subscribing: "Subscribing…",
    noSpamEver: "No spam, ever",
    dailyPanchang: "Daily Panchang",
    festivalAlerts: "Festival Alerts",
    successLong: "You are subscribed! Daily Panchang will arrive on WhatsApp.",
    successShort: "Subscribed! Daily Panchang will arrive on WhatsApp.",
    successBanner: "Subscribed!",
    errorInvalid: "Please enter a valid phone number.",
    errorInvalidTen: "Please enter a valid 10-digit mobile number.",
    errorGeneric: "Something went wrong. Try again.",
    errorNetwork: "Network error. Please try again.",
    errorGenericLater: "Something went wrong. Please try again.",
    errorNetworkLater: "Network error. Please try again later.",
  },
  guruSlider: {
    sectionAriaLabel: "Divine Guruji",
    headingLine1: "Get Divine Guidance from",
    headingLine2: "Renowned Astrologers.",
    cta: "Find your Divine Guruji",
    opensNewTab: "opens in a new tab",
    guru: {
      bhrigu: {
        name: "Bhrigu Rishi",
        desc: "Father of Shukracharya (guru of the Asuras), master of astrology and rituals.",
      },
      atri: {
        name: "Atri Rishi",
        desc: "Author of many hymns in the Rigveda, a seer of cosmic truths.",
      },
      kutsa: {
        name: "Kutsa Rishi",
        desc: "Known for spiritual vision and association with Indra.",
      },
      angiras: {
        name: "Angiras Rishi",
        desc: "Linked with knowledge of rituals, fire worship and mantras.",
      },
      kashyapa: {
        name: "Kashyapa Rishi",
        desc: "Forefather of many beings (Devas, Asuras, Nagas, mankind).",
      },
      vashistha: {
        name: "Vashistha Rishi",
        desc: "Royal priest of the Ikshvaku dynasty (Rama's lineage), symbol of wisdom and patience.",
      },
      gautama: {
        name: "Gautama Rishi",
        desc: "Associated with many Rigvedic hymns; known for the story of Ahalya.",
      },
    },
  },
  login: {
    welcomeTitle: "Welcome",
    mobileOtpSubtitle: "Enter your mobile number to receive OTP.",
    mobileNumberLabel: "Mobile number",
    mobileNumberPlaceholder: "e.g. 9876543210",
    invalidIndianMobile: "Enter a valid 10-digit Indian mobile number (must start with 6, 7, 8, or 9).",
    blockedTestMobile: "This number cannot be used. Please enter your real mobile number.",
    signInTitle: "Sign in",
    passwordSubtitle: "Enter your mobile number or email and your password.",
    mobileOrEmail: "Mobile number or email",
    mobileOrEmailPlaceholder: "10-digit mobile or email",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    signInButton: "Sign in",
    signingIn: "Signing in...",
    loginWithPassword: "Login with password",
    loginWithOtp: "Login with OTP instead",
    loginFailed: "Login failed",
    otpVerifyFailed: "Could not verify. Please check the OTP and try again.",
    otpSendCooldown: "Please wait {n}s before requesting another OTP.",
    waitSendOtp: "Wait {n}s",
    otpTooManyAttempts: "Too many incorrect OTPs. Sending a new code is paused for {n}s.",
    otpInvalidAttempts: "Invalid OTP attempts: {current}/{max}",
    enterMobileOrEmail: "Enter your mobile number or email",
    showPassword: "Show password",
    hidePassword: "Hide password",
  },
  home: {
    fcEyebrow: "PLAN AHEAD",
    fcTitle: "Auspicious Festival Calendar",
    fcSubtitle: "Book your pooja for sacred occasions — performed by certified acharyas at India's most powerful Kshetras.",
    fcDaysAway: "{n}d away",
    fcRecommended: "Recommended pooja",
    fcBookNow: "Book Now",
    heroMotto: "ध धर्मो रक्षति रक्षितः Dharma Protects Those Who Protect It",
    heroHeading1: "Sacred Rituals.",
    heroHeading2: "Powerful",
    heroHeading3: "Kshetras.",
    heroHeading4: "Your Sankalpa.",
    heroDesc: "Connecting devotees to authentic pujas, sevas, and the sacred traditions of Sanatana Dharma through Mahan Acharya performed in your name at India's most powerful Kshetras.",
    bookAPooja: "Book a Pooja",
    watchHowItWorks: "Watch How It Works",
    liveNow: "LIVE NOW",
    devoteeRating: "Devotee Rating",
    devoteesServed: "Devotees Served",
    loadingPoojas: "Loading poojas…",
    noLivePoojas: "No live poojas at the moment. Check upcoming or Poojas Performed.",
    bookNow: "Book Now",
    specialEvent: "Special Event",
    livePoojas: "Live Poojas",
    livePoojasDesc: "Current poojas. Tap a card to view details and book.",
    devoteeExperiences: "Devotee Experiences",
    devoteeExperiencesEyebrow: "Verified Devotees",
    devoteeExperiencesHeading: "What Devotees Say",
    verified: "Verified",
    poojaGallery: "Pooja Gallery",
    youtubeShorts: "YouTube Shorts",
    youtubeShortsDesc: "Watch our latest Shorts",
    divineMoments: "Daiv moments",
    divineMomentsDesc: "Watch Our Latest Shorts",
    momentsEyebrow: "Daiv moments",
    momentsKnowMore: "Know more",
    momentsShortTitle: "Latest shorts",
    watchOnYouTube: "Watch on YouTube",
    statsRituals: "500+ Rituals Performed",
    statsKshetras: "50+ Kshetras",
    statsDevotees: "2,00,000+ Devotees Served",
    statsLiveTelecast: "Live Telecast Every Ritual",
    statsVedic: "100% Vedic Authenticity",
    statsRating: "4.9 Devotee Rating",
    sacredJourneyMotto: "SIMPLE. SACRED. AUTHENTIC.",
    sacredJourneyTitle: "Begin Your Sacred Journey",
    sacredJourneySubtitle: "Three simple steps to connect with the divine from anywhere in the world.",
    sacredJourneyStep1Hi: "पूजा चयन",
    sacredJourneyStep1En: "Choose Your Pooja",
    sacredJourneyStep1Desc: "Select from our curated list of authentic rituals — each verified by Vedic scholars.",
    sacredJourneyStep2Hi: "संकल्प निर्माण",
    sacredJourneyStep2En: "Ideate Your Sankalpa",
    sacredJourneyStep2Desc: "Share your name, gotra, and heartfelt intention. Our acharyas chant your Sankalpa aloud.",
    sacredJourneyStep3Hi: "प्रसाद प्राप्ति",
    sacredJourneyStep3En: "Receive Blessings",
    sacredJourneyStep3Desc: "Watch the live telecast, receive your digital video recording, and sacred prasadam.",
    sacredJourneyCta: "Begin Your Sankalpa",
    upcomingAuspiciousBadge: "UPCOMING AUSPICIOUS DATES",
    featuredPoojasBadge: "FEATURED POOJAS",
    sacredRitualsHomas: "Sacred Rituals & Homas",
    viewAll: "View All",
    featured: "FEATURED",
    popular: "POPULAR",
    bookArrow: "Book",
    bookingClosesIn: "BOOKING CLOSES IN",
    poojaStartsIn: "POOJA IN",
    onlyLimitedSlotsAvailable: "Only limited slots available",
    founderVisionKnowMore: "Know more",
    founderVisionDescBefore: "Launched under divine blessings of ",
    founderVisionDescGuruName: "Swami Avadeshanand Giriji Maharaj",
    founderVisionDescMiddle: " at Prayagraj Mahakumbh on 7th February 2025 with our cofounders ",
    founderVisionDescCofounder1: "Dr. Samartha Nagabhushanam",
    founderVisionDescCofounderBetween: " and ",
    founderVisionDescCofounder2: "Dr. Manasa Nagabhushanam",
    founderVisionDescEnd: ".",
    founderVisionDesc2: "To digitally preserve and deliver the spiritual wisdom, devotional traditions, and sacred practices of Bharat to seekers everywhere.",
    founderVisionHeritageHeading: "Founder's Vision",
    founderVisionCaptionSamartha: "Dr. Samartha Raghava Nagabhushanam",
    founderVisionCaptionManasa: "Dr. Manasa Nagabhushanam",
    mobileHero: {
      subtitle:
        "Book sevas, talk to Guruji, follow panchang, and stay with mantras, clips, and community — on Android and iOS.",
      exploreFullApp: "Explore the Full App",
      badgeIosAndroid: "iOS & Android",
      badgeReviews: "4.9 · 2L+ Devotees",
    },
  },
  trust: {
    sacredTemplePujas: "Sacred Temple Pujas",
    byMahanAcharyas: "By Mahan Acharyas",
    personalisedSankalpa: "Personalised Sankalpa",
    liveTelecast: "Live Telecast",
    prasadamDeliveredHome: "Prasadam Delivered Home",
  },
  upcoming: {
    title: "Poojas & Homas",
    desc: "Authentic Vedic rituals performed by verified acharyas at India's most powerful Kshetras — in your name.",
    ritualsBadge: "Sacred Rituals Available",
    searchPlaceholder: "Search by ritual, deity, or kshetra...",
    noSearchResults: "No matching poojas found.",
    tabLive: "Live",
    tabUpcoming: "Upcoming",
    tabArchived: "Performed",
    tabFavorites: "Favorites",
    noFavorites: "No favorite poojas yet. Log in and add some!",
    noFavoritesEmpty: "You have no favorite poojas yet. Browse and add some!",
    viewDetails: "View Details",
    loading: "Loading poojas…",
    noPoojas: "No upcoming poojas are scheduled right now — new dates are added regularly. See what you can book today.",
    viewLivePoojas: "View live poojas",
    noLivePoojas: "No live poojas at the moment.",
    noArchivedPoojas: "No poojas here yet.",
    suggestionLive: "Live",
    suggestionUpcoming: "Upcoming",
    suggestionArchived: "Performed",
    voiceSearch: "Voice search",
    listeningOrType: "Listening... or type",
    filters: "Filters",
    deity: "Deity",
    poojaCategory: "Pooja Category",
    tithi: "Tithi",
    daysOfGrace: "Days of Grace",
    all: "All",
    priceRange: "Price Range",
    allPrices: "All Prices",
    under1000: "Under ₹1,000",
    price1000to5000: "₹1,000-₹5,000",
    above5000: "Above ₹5,000",
    duration: "Duration",
    anyDuration: "Any Duration",
    under1hr: "Under 1 hr",
    duration1plus: "1+ hrs",
    ritualsFound: "rituals found",
    mostPopular: "Most Popular",
    sortByPrice: "Price: Low to High",
    sortByDate: "Date: Soonest",
    viewAll: "View All",
    showLess: "Show Less",
    filterViewAllClose: "Close",
    filterViewAllSearch: "Search options…",
    filterViewAllEmpty: "No matches. Try another search.",
    filterViewAllDone: "Done",
    filterSelected: "Selected",
    filterMultiSelectHint: "Tap multiple options to combine filters",
    filterResetAll: "Reset",
    sortLabel: "Sort",
    sortBy: "Sort by",
    clearAll: "Clear all",
    showResults: "Show {count} rituals",
    activeFilters: "Active filters",
    removeFilter: "Remove filter: {label}",
    searchingMore: "Loading more poojas…",
    filterPrev: "Previous",
    filterNext: "Next",
    popular: "Popular",
    auspicious: "Auspicious",
    next: "Next",
    perBooking: "per booking",
    viewingNow: "viewing now",
    slotsLeft: "slots left",
  },
  past: {
    title: "Poojas Performed",
    archivedBadge: "Archived",
    desc: "Poojas that are inactive or whose booking date and time are over.",
    viewDetails: "View Details",
    loading: "Loading poojas…",
    noPoojas: "No poojas here yet.",
    whatDevoteesSay: "What Devotees Say",
    experiencesIntro: "Experiences from past poojas and homas.",
    poojaGallery: "Pooja Gallery",
  },
  gallery: {
    title: "Divine Moments",
    heroTitle: "Divine Moments",
    description: "Sacred rituals, Kshetras, prasadam moments, and live ceremonies from Daiv Bharathi.",
    subtitle: "Witness the sacred rituals and kshetras that bless thousands of devotees worldwide.",
    filtersAria: "Gallery categories",
    filterAll: "All",
    filterRituals: "Rituals",
    filterKshetras: "Kshetras",
    filterPrasadam: "Prasadam",
    filterLive: "Live Ceremonies",
    categoryUnnamed: "Category",
    empty: "No images in this category yet.",
    loading: "Loading gallery…",
    loadError: "Could not load the gallery. Please try again later.",
    imageFallbackAlt: "Gallery image",
    playShort: "Play short",
    modeTabsAria: "Gallery or shorts",
    tabDivineGallery: "Divine Gallery",
    tabDivineShorts: "Daiv moments",
    shortsLoading: "Loading shorts…",
    shortsEmpty: "No shorts available yet.",
  },
  footer: {
    daivBharathis: "Daiv's",
    downloadOurApps: "Download our apps",
    whatsApp: "WhatsApp",
    installApp: "Install App",
    poojasAndHomas: "Poojas and Homas",
    inPowerfulKshetras: "In Powerful Kshetras",
    byMahanAcharyas: "By Mahan Acharyas",
    withPersonalisedSankalpa: "With Personalised Sankalpa",
    liveTelecast: "Live Telecast",
    prasadamToHome: "Prasadam to Home",
    backToTop: "Back to top",
    brandDescription:
      "India's premier AI-powered spiritual platform connecting devotees to authentic pujas, sevas, and the transformative traditions of Sanatana Dharma.",
    navSacredPoojas: "Sacred Poojas",
    navExplore: "Explore",
    navCompany: "Company",
    linkShivaHomas: "Shiva Homas",
    linkVishnuPoojas: "Vishnu Poojas",
    linkDeviSevas: "Devi Sevas",
    linkNavagrahaPujas: "Navagraha Pujas",
    linkGaneshaSevas: "Ganesha Sevas",
    linkTemplesDirectory: "Temples Directory",
    linkDailyPanchang: "Daily Panchang & Horoscope",
    linkConsultGuruji: "Consult a Guruji",
    linkGallery: "Gallery",
    linkSpiritualBlog: "Spiritual Blog",
    linkNriServices: "NRI Services",
    linkAboutUs: "About Us",
    linkFounderStory: "Founder Story",
    linkContactSupport: "Contact Support",
    linkForKshetras: "For Kshetras (B2B)",
    copyrightLine: "© 2023-2026 Daiv Bharathi. All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    refundPolicy: "Refund Policy",
    highlightsSectionAria: "Daiv Bharathi highlights",
    whatsappFabAria: "Chat with Daiv Bharathi on WhatsApp",
    videoFabAria: "Daiv Nitya — daily spiritual videos",
    supportFabAria: "Open support",
    supportDrawerTitle: "Support",
    supportChatGreeting: "Hi! How can we help you today?",
    supportContactGroup: "Talk to us",
    supportExploreGroup: "Explore",
    supportCall: "Call us",
    supportWhatsApp: "Chat on WhatsApp",
    supportEmail: "Email us",
    supportDaivNitya: "Daiv Nitya",
    supportPoojasMeta: "Book a pooja or homa",
    supportClose: "Close",
    goHomeAria: "Go to home",
    socialAria: "Social media",
  },
  booking: {
    formTitle: "Booking Form",
    scrollForMore: "Scroll for more",
    step1Title: "Add Devotee Details",
    step1Line1: "Add Devotee",
    step1Line2: "Details",
    step1Desc: "Add devotee details",
    fallbackFieldsNotice: "Enter the required fields below (name and mobile) to continue to payment.",
    megaSessionDate: "Choose pooja date",
    megaSessionTime: "Pooja time",
    megaInvalidSlot: "Choose a valid date and time from the schedule.",
    personalizedDateBlocked: "This date is not available. Please choose another day.",
    personalizedAddressRequired: "Please enter your delivery address and pincode for this personalized pooja.",
    noFieldsError: "Unable to show booking fields. Please refresh or contact support.",
    fieldKindText: "Text",
    fieldKindPhone: "10-digit mobile",
    invalidMobile: "Please enter a valid 10-digit mobile number.",
    invalidEmail: "Please enter a valid email address.",
    optionalSuffix: "(optional)",
    loadingOptions: "Loading options…",
    noMatchingOptions: "No matching options",
    gotraOthersLabel: "Others",
    gotraOthersPlaceholder: "Type your gotra here",
    gotraOthersHint: "Enter your gotra name",
    gotraOthersConfirm: "Confirm gotra",
    gotraDontKnow: "I don't know my gotra",
    whatsappNumberLabel: "Your mobile Number",
    whatsappNumberHint: "(We will send puja confirmation & updates via WhatsApp)",
    sankalpaAfterPaymentNote: "After completing this payment, you can add sankalpa and family details.",
    step2Title: "Secure Payment",
    step2Line1: "Secure",
    step2Line2: "Payment",
    step2Desc: "Review your booking and proceed to payment.",
    step3Title: "Add Family Sankalpa Details",
    step3Line1: "Add Family",
    step3Line2: "Sankalpa Details",
    step3Desc: "Add sankalpa details for the ritual. The priest will announce your intention during the pooja.",
    step4Title: "Get Pooja Updates",
    step4Line1: "Get Pooja",
    step4Line2: "Updates",
    step4Desc: "Get pooja updates after your booking.",
    devoteeName: "Devotee Name",
    contactNameLabel: "Name (first person name)",
    purpose: "Your wish",
    purposePlaceholder: "Share your prayers and wish",
    devoteeNamePlaceholder: "Full name as per kundali",
    devoteeNameHelp: "Enter name in English. Priest will chant in Sanskrit.",
    gotram: "Gotram",
    gotramPlaceholder: "e.g. Kashyapa (optional)",
    yourWish: "Your Wish / Intention",
    yourWishPlaceholder: "What specific blessing do you seek? (e.g. Good health for my mother, Success in my business venture...)",
    yourWishHelp: "The priest includes your intention in the ritual prayer. Be specific and heartfelt.",
    continueBtn: "Continue >",
    orderSummary: "ORDER SUMMARY",
    gstLabel: "GST (0%)",
    gstExempt: "Exempt",
    prasadDelivery: "Prasad Delivery",
    prasadFree: "Free",
    needPrasadamLabel: "Receive Sacred Prasadam?",
    needPrasadamDesc: "Carry the blessings of this sacred Pooja home.",
    needPrasadamDescWithFee: "Doorstep delivery · +₹{amount} (package price stays separate).",
    needPrasadamDoorstep: "Doorstep delivery",
    needPrasadamNo: "NO",
    needPrasadamYes: "YES",
    prasadamWantBlessings: "Yes, I Want to Receive Sacred Prasadam & Blessings 🙏",
    prasadamSelectYesHint: "Would you like to receive Prasadam & Blessings?",
    prasadamSelectYesHintLine: "Please select “Yes”.",
    prasadamDetailsShow: "Details",
    prasadamDetailsHide: "Hide",
    prasadamConfirmNotice: "Attention: prasadam delivery will be added to this booking. Please confirm below.",
    prasadamConfirmCheckbox: "Yes, I want prasadam now",
    prasadamConfirmRequired: "Please confirm you want prasadam delivery.",
    prasadamDeliverySectionTitle: "Prasadam delivery address",
    prasadamDeliverySectionDesc: "Enter the full address and PIN code where we should send prasadam.",
    prasadamSkipBlockedHint: "Add prasadam delivery address before skipping.",
    prasadamAddressRequired: "{label} is required for prasadam delivery",
    selectStateFirst: "Select state first",
    selectDistrictFirst: "Select district first",
    locationTypeToSearch: "Type to search…",
    sevasTitle: "Add-on Sevas",
    sevasHint: "Optional offerings — choose any you want",
    sevasSeeMore: "See more",
    sevasSeeLess: "See less",
    sevasAdd: "Add",
    sevasRemove: "Remove",
    sevasCloseDetail: "Close",
    sevasPrev: "Previous seva",
    sevasNext: "Next seva",
    sevasEnlarge: "Enlarge image",
    sevasDone: "Done",
    sevasSelectedCount: "{n} selected",
    enlargePoojaImage: "View pooja image",
    sevasEnablePrasadamHint: "Select Yes for prasadam to add sevas",
    sevasLine: "Sevas",
    couponLabel: "Coupon code",
    couponHint: "If you have a coupon code, add it here",
    couponPlaceholder: "Enter code",
    couponApply: "Apply",
    couponApplied: "Applied",
    couponRemove: "Remove",
    couponEnterCode: "Enter a coupon code",
    couponDiscount: "Discounts",
    couponPoojaOnly: "Coupon applies to the pooja package only — not prasadam or add-on sevas.",
    priceBreakup: "Price breakup",
    prasadLine: "Prasad",
    addOnSevasLine: "Add-on sevas",
    youSaved: "You saved ₹{amount}",
    youSavedShort: "saved {amount}",
    discountUnlockedTitle: "Congratulations!",
    discountUnlockedBody: "You unlocked {percent}% off",
    discountUnlockedSaved: "You save ₹{amount}",
    discountUnlockedOriginal: "Original price",
    discountUnlockedDiscount: "Discount",
    discountUnlockedFinal: "Final price",
    discountUnlockedGreat: "Great",
    totalWithSaved: "Total (saved {amount})",
    couponInvalid: "Coupon is not valid",
    selectAcharyaTitle: "Choose your Acharya",
    selectAcharyaEyebrow: "Personalized sankalpa",
    selectAcharyaCount: "{n} available",
    selectAcharyaDesc: "These Acharyas are assigned to your booking. Swipe and tap to select one (optional).",
    selectAcharyaRequired: "Please select an Acharya for your personalized pooja.",
    selectAcharyaAddressHint: "Select your state, district, and pincode above to see matching Acharyas.",
    selectAcharyaNoneForPincode: "No Acharyas are available for the selected pincode. Please contact support.",
    selectAcharyaPreferredBadge: "Recommended",
    selectAcharyaTap: "Tap to select",
    selectAcharyaSelected: "Selected",
    selectAcharyaYourChoice: "Your Acharya:",
    selectAcharyaScrollHint: "Swipe to browse Acharyas →",
    selectAcharyaCardLabel: "Select Acharya {name}",
    prasadamPincodeInvalid: "Please enter a valid 6-digit pincode",
    prasadamSubmitRequiredHint: "Please fill address and 6-digit pincode to submit",
    total: "Total",
    reviews: "reviews",
    booked: "booked",
    poojaInYourName: "Pooja in your name",
    breadcrumbBook: "Book",
    advisorWhatsAppGuide: "Hi, I want a guide for booking this {name}.",
    liveStreamLink: "Live stream link",
    trustShastra: "Shastra-compliant ritual procedure",
    trustAcharyas: "Verified acharyas only",
    proceedToRazorpay: "Proceed to Razorpay",
    payNow: "Pay Now",
    payNowForPackage: "Pay Now for {package} — ₹{amount}",
    prasadamQuestion: "Receive Prasadam & Blessings at home?",
    couponToggle: "Have a coupon code?",
    securePayLine: "Secure payment via Razorpay · UPI & cards",
    refundPolicyLink: "Refund policy",
    paymentCouldNotStart: "We couldn't start the payment. Please try again, or chat with us.",
    fieldRequired: "{field} is required",
    redirecting: "Redirecting to payment...",
    paymentCancelledNotice: "Payment was cancelled. Tap Pay Now below to try again.",
    preparingAutopay: "Preparing your booking… Please wait.",
    paymentSuccess: "Payment successful!",
    addPersonDetails: "Add person details for sankalpa",
    personName: "Name",
    personGothra: "Gothra",
    personNakshatra: "Nakshatra",
    personRashi: "Rashi",
    addPerson: "Add another person",
    maxPersonsReached: "Maximum number of persons reached",
    minMembers: "Min",
    personLabel: "Devotee",
    personFieldLabel: "Person {n} {attr}",
    backToPooja: "Back to pooja",
    poojaInfo: "Pooja Info",
    secureCheckout: "Secure Checkout",
    securePayment: "Secure Payment",
    personNameRequired: "Please add at least one person with name.",
    removePerson: "Remove",
    removePersonConfirmTitle: "Remove this person?",
    removePersonConfirmBody: "Do you want to remove Person {n} details?",
    removePersonConfirmNo: "No",
    removePersonConfirmYes: "Yes, remove",
    submitPersonDetails: "Submit details",
    personDetailsSuccess: "Person details saved successfully!",
    thankYouDetailsSavedHint: "Your devotee details are saved. View your invoice or review your details anytime.",
    thankYouYourDetailsTitle: "Your details",
    thankYouBackToSummary: "Back",
    viewMyOrders: "View my bookings",
    viewInvoice: "View Invoice",
    skipForNow: "Skip for now",
    orderConfirmedTitle: "Thank you – Order Confirmed",
    orderConfirmedDesc: "Your pooja booking is confirmed. Add person details to complete.",
    thankYouConfirmedBadge: "Booking confirmed",
    thankYouPackage: "Package",
    thankYouAmountPaid: "Amount paid",
    thankYouBookingId: "Booking ID",
    thankYouDeliveryEyebrowPersonalized: "Delivery & sankalpa",
    bhagalamukhiThankYouWhatsTitle: "Join the WhatsApp group",
    bhagalamukhiThankYouWhatsDesc: "Get updates and coordination for Bhagavati Bhagalamukhi sadhana and the akhand havan.",
    narasimhaThankYouWhatsDesc: "Get updates and coordination for Narasimha Jayanthi Pooja.",
    poojaThankYouWhatsDesc: "Join this WhatsApp group for updates and coordination for your booked pooja.",
    bhagalamukhiThankYouWhatsCta: "Open WhatsApp group",
    thankYouWhatsClickHere: "Click here",
    thankYouWhatsJoinTitle: "Join the WhatsApp group",
    thankYouWhatsJoinDesc: "Join this WhatsApp group and get more updates for this pooja.",
    bhagalamukhiThankYouWhatsQrHint: "Scan this QR code with your phone camera to join the group in WhatsApp.",
    bhagalamukhiThankYouWhatsQrAlt: "QR code for WhatsApp group invite",
    bhagalamukhiThankYouWhatsLinkLabel: "Group invite link",
    bhagalamukhiThankYouWhatsCopy: "Copy link",
    bhagalamukhiThankYouWhatsCopied: "Copied!",
    editPersonDetails: "Edit person details",
    cancelRequest: "Cancel",
    cancelRequestTitle: "Request cancellation",
    cancelRequestDesc: "You can add an optional reason below. Our team will review your request.",
    cancelRequestPlaceholder: "Optional reason (e.g. personal circumstances)",
    cancelRequestSubmit: "Submit request",
    cancelRequestSuccess: "Cancel request submitted successfully.",
    cancelRequestAlreadyExists: "A cancel request already exists for this booking.",
    cancelRequestPending: "Cancellation pending",
    cancelRequestRequested: "Cancellation requested",
    cancelRequestCancelled: "Cancelled",
    cancelRequestNotApproved: "Cancellation not approved",
    cancelRequestConfirmTitle: "Raise a cancel request?",
    cancelRequestConfirmBody: "Do you want to submit a cancellation request for this booking? Our team will review it. You can also contact support below before proceeding.",
    cancelRequestConfirmSupport: "Contact support",
    cancelRequestSupportCall: "Call",
    cancelRequestSupportWhatsApp: "WhatsApp",
    cancelRequestSupportEmail: "Email",
    cancelRequestConfirmYes: "Yes",
    cancelRequestStatusTitle: "Cancellation request",
    cancelRequestYourReason: "Your reason",
    cancelRequestTeamDecision: "Team response",
    cancelRequestNoDecisionYet: "No response yet.",
    cancelRequestViewDetails: "View details",
  },
  about: {
    title: "About Us",
    subtitle: "Connecting devotees with sacred traditions",
    intro1: "Daiv Bharathi is a spiritual platform dedicated to fulfilling the sacred needs of devotees, especially in today's fast-paced world where finding time for traditional poojas and homas can be challenging.",
    intro2: "What sets Daiv Bharathi apart is its deeply personal and authentic experience:",
    listCustomizedSankalpa: "Customized sankalpa for every devotee",
    listPandits: "Rituals performed by learned pandits who are immersed in sadhana and anushtana",
    listAcharyas: "Blessings from revered acharyas",
    listLiveStreaming: "Live streaming of every ceremony",
    listPrasada: "Sacred prasada delivered to your doorstep",
    closing: "Devotees across the globe have embraced the divine connection and spiritual fulfillment offered by Daiv Bharathi.",
    ourLeadership: "Our Leadership",
    ourFounders: "Our Founders",
    foundersIntro: "Daiv Bharathi was founded with the vision of bringing sacred rituals and spiritual wisdom closer to devotees across the world.",
    chairmanCoFounder: "Chairman & Co-Founder",
    ceoCoFounder: "CEO & Co-Founder",
    advisors: "Advisors",
    advisoryPanel: "Advisory panel",
    close: "Close",
    prevImage: "Previous image",
    nextImage: "Next image",
    launchCaption1: "Co-Founders Dr. Samartha Nagabhushanam and Dr. Manasa Nagabhushanam during the launch",
    launchCaption2: "Launch of Daiv app by Swami Avadeshanand Giriji Maharaj, Mahamandaleshwar, Juna Akhada at Praygraj on 7th February 2025",
    missionTitle: "Our Mission",
    missionBody: "To bridge the geographical gap between devotees and the sacred Kshetras of India. We ensure that distance never becomes a barrier to spiritual fulfillment, bringing authentic rituals directly to you, wherever you are.",
    visionTitle: "Our Vision",
    visionBody: "To be the world's most trusted and authentic digital sanctuary for Sanatana Dharma, where every sankalpa is honored with pure devotion and profound Vedic accuracy.",
    missionVisionSectionAria: "Mission and vision",
    founderStorySectionAria: "Co-founder's story",
    founderStoryTitle: "Co-Founder's Story",
    founderPhotoAlt: "Dr. Samartha Nagabhushanam",
    founderStatNumber: "30+",
    founderStatLine1: "Years of Service",
    founderStatLine2: "in building business",
    founderQuote: "Dr. Samartha Nagabhushanam envisions Daiv Bharathi as a transformative faith platform that uses technology to make the spiritual and cultural wealth of Bharath accessible, engaging, and relevant to modern seekers. His vision is to create a seamless digital ecosystem where devotion, sacred knowledge, and spiritual practices can be experienced meaningfully in everyday life.\n\nHe believes technology can play a powerful role in preserving and propagating timeless dharmic wisdom across generations.",
    founderQuoteBy: "— Dr. Samartha Nagabhushanam",
    founderStoryP1: "Dr. Samartha Nagabhushanam is the Founder of Daiv Bharathi and a global entrepreneur, investor, and transformational leader with a distinguished track record of leading four publicly listed companies and scaling businesses of USD 2–3 billion. With deep experience across global innovation, strategic growth, and large-scale execution, he brings vision, purpose, and leadership to every initiative he builds.",
    founderStoryReadMore: "Read more",
    founderStoryShowLess: "Show less",
    founderStoryP2: "Through Daiv Bharathi, he seeks to contribute to a larger cultural and spiritual awakening by helping revive the sacred wisdom, devotion, and timeless values of Bharath. His journey reflects a rare blend of enterprise, impact, and a deeper commitment to meaningful societal transformation.",
    founderBadgeDlitt: "Global Entrepreneur",
    founderBadgeCountries: "Transformational Leader",
    founderBadgeScholar: "Technocrat",
    founderBadgeKshetras: "Business Visionary",
    founderStorySectionAriaManasa: "Co-founder's story — Dr. Manasa Nagabhushanam",
    founderStoryTitleManasa: "Co-Founder's Story",
    founderPhotoAltManasa: "Dr. Manasa Nagabhushanam",
    founderStatNumberManasa: "20+",
    founderStatLine1Manasa: "Business education",
    founderStatLine2Manasa: "leader",
    founderQuoteManasa: "Our mission is to awaken and nurture bhakthi, deepen the living experience of the Divine, and revive the sacred power of sankalpa in everyday life.\n\nThrough this, we aspire to help Bharath return to its spiritual roots — where devotion, dharma, and inner transformation once shaped both the individual and the nation.",
    founderQuoteByManasa: "— Dr. Manasa Nagabhushanam",
    founderStoryP1Manasa: "Dr. Manasa Nagabhushanam is the Co-founder of Daiv Bharathi, guided by a deep commitment to revive bhakthi, dharma, and the living experience of the Divine in everyday life. With a distinguished background in business education, she has served as a Professor of Management, held academic leadership roles in leading business schools, and worked as a writer and consultant.",
    founderStoryP2Manasa: "She has guided nine women scholars toward their PhD and has been recognized with several awards for her contribution as an education leader. Through Daiv Bharathi, she seeks to bring together wisdom, purpose, and spiritual rootedness to help Bharath reconnect with its sacred and devotional heritage.",
    founderBadgeManasaEdu: "Meditation practitioner",
    founderBadgeManasaPhd: "Yoga coach",
    founderBadgeManasaVeda: "Spiritual seeker",
    founderBadgeManasaCommittees: "Ancient wisdom & scriptures",
    samarthaBio: "Dr. Samartha Raghava Nagabhushanam is a scholar and visionary dedicated to blending spirituality with knowledge. Holding a D. Litt. in Management, an Honorary D. Litt. in Business Administration, and a Master's in Religion & Philosophy, his journey spans over 30 years across 17 countries. Rooted in deep spiritual wisdom, and more than three decades of industry experience, he bridges ancient teachings with modern understanding, guiding seekers toward a higher purpose.",
    manasaBio: "Dr. Manasa Nagabhushanam is an entrepreneur, education leader, and writer devoted to blending ancient wisdom with modern learning. Acclaimed for her work in business education, she has guided nine women scholars to their doctorates and served on university and government committees. With a deep passion for the Veda, Yoga, and Sanskrit scriptures, she is dedicated to spreading spiritual knowledge and bridging ancient wisdom with contemporary seekers worldwide.",
  },
  contact: {
    title: "Contact Us",
    heroSubtitle: "How to Reach Us",
    ourLocation: "Our Location",
    companyName: "DAIVBHARATHI TECHNOLOGIES PRIVATE LIMITED",
    registeredOffice: "Registered Office:",
    addressRegistered:
      "1st Floor, No. 63\n7th Block\nKoramangala VI Block\nBengaluru – 560095\nBengaluru Urban District\nKarnataka, India",
    gstLabel: "GST Number:",
    gstNumber: "29AAMCD7390R1ZH",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
  },
  daivNitya: {
    heroTitle: "Daiv Nitya",
    heroSubtitle: "Daily spiritual moments — fresh videos and imagery curated for your sadhana.",
    pageTitle: "Daiv Bharathi | Daiv Nitya",
    seoDescription: "Daiv Nitya — daily approved spiritual videos and visuals from Daiv Bharathi.",
    loading: "Loading Daiv Nitya…",
    empty: "No Daiv Nitya media is available yet. Please check back soon.",
    loadError: "Could not load Daiv Nitya. Please try again later.",
    mediaTypeVideo: "Video",
    mediaTypeImage: "Image",
    playAria: "Play video",
    pauseAria: "Pause video",
    closeAria: "Close",
    dateLabel: "Date",
    languageLabel: "Language",
    likesLabel: "likes",
    likeLabel: "like",
    shareLabel: "Share",
    shareAria: "Share this Daiv Nitya media",
    fullscreenLabel: "Full",
    fullscreenAria: "Play in full screen",
    likeAria: "Like this Daiv Nitya media",
    muteAria: "Mute video",
    unmuteAria: "Unmute video",
    muteLabel: "Mute",
    unmuteLabel: "Unmute",
    moreLabel: "more",
    lessLabel: "less",
    viewAllAria: "View all Daiv Nithya posts",
    gridPageTitle: "Daiv Nithya",
    gridSubtitle: "All posts",
    gridEmpty: "No Daiv Nitya posts yet. Please check back soon.",
    backToReels: "Back to reels",
  },
  blogs: {
    heroTitleMain: "Daiv Vani",
    heroTitleSub: "The Daiv blog",
    heroDesc: "Deepen your understanding of Sanatana Dharma, ancient traditions, temples, and devotional traditions.",
    subtitle: "Spiritual guides, sacred stories, and ritual insights",
  },
  store: {
    heroTitleMain: "Daiv Store",
    heroTitleSub: "Pooja essentials & spiritual products",
    heroDesc: "Curated oils, ghee, lamp supplies, and ritual essentials verified for temple worship and home pooja.",
    searchPlaceholder: "Search products...",
    categoriesAria: "Product categories",
    filtersAria: "Store filters",
    categoryFilterLabel: "Category",
    purposeFilterLabel: "Shop for",
    allPurposes: "All purposes",
    priceFilterLabel: "Price",
    priceSortFeatured: "Featured",
    priceSortLow: "Low to high",
    priceSortHigh: "High to low",
    hideOutOfStock: "Hide out of stock",
    showAllStock: "Show all",
    stockFilterLabel: "Stock",
    resultsCount: "{n} products",
    productNotFound: "Product not found.",
    backToStore: "Back to store",
    allCategories: "All",
    empty: "Products coming soon. Check back for pooja essentials and spiritual items.",
    noResults: "No matching products found.",
    loadError: "Could not load products. Please try again.",
    outOfStock: "Out of stock",
    selectVariant: "Choose variant",
    sectionTitle: "New Arrivals",
    addToCart: "Add to cart",
    addedToCart: "Added",
    buyNow: "Buy now",
    cartTitle: "Your Cart",
    cartButton: "Cart",
    cartPromo: "Verified pooja essentials — delivered to your doorstep",
    cartEmpty: "Your cart is empty. Add products to continue.",
    cartRemove: "Remove item",
    cartSaved: "saved so far!",
    cartEstimatedTotal: "Estimated Total",
    cartCheckout: "Checkout",
    cartFootnote: "Secure checkout with Razorpay",
    cartAddError: "Could not add to cart. Please try again.",
    cartGuestNote: "Enter your delivery address at checkout. Sign in to use saved addresses.",
    cartSignInToCheckout: "Checkout",
    checkoutOrderSummary: "Order summary",
    checkoutTitle: "Checkout",
    checkoutQuantity: "Quantity",
    checkoutDecreaseQty: "Decrease quantity",
    checkoutIncreaseQty: "Increase quantity",
    checkoutTotal: "Estimated total",
    checkoutSubtotal: "Subtotal",
    checkoutDelivery: "Delivery",
    checkoutDeliveryFree: "Free",
    checkoutGst: "GST",
    checkoutGrandTotal: "Total",
    checkoutDeliveryPending: "Select a delivery address to see order total and delivery charges.",
    checkoutNoAddresses: "Add a delivery address to continue checkout.",
    checkoutFillFromSaved: "Fill from saved address",
    checkoutDeliveryCalculating: "Calculating…",
    checkoutDeliveryError: "Could not calculate delivery. Try again or continue — Razorpay shows the final amount.",
    checkoutDeliveryAddress: "Delivery address",
    checkoutAddAddress: "Add address",
    checkoutAllFieldsRequired: "All fields marked * are required",
    checkoutSelectAddress: "Please select a delivery address.",
    checkoutSelectAddressTitle: "Select delivery address",
    checkoutDeliverHere: "Deliver here",
    checkoutAddressLoadError: "Could not load your addresses.",
    checkoutPayNow: "Pay with Razorpay",
    checkoutOpeningRazorpay: "Opening Razorpay…",
    checkoutPaymentCancelled: "Payment was cancelled.",
    checkoutPaymentFailed: "Payment could not be completed. Please try again.",
    checkoutLoginTitle: "Login to continue",
    checkoutLoginContinue: "Continue",
    checkoutLoginFirstHint: "Sign in with your mobile number to add a delivery address and pay.",
    checkoutVerifyOtpTitle: "Verify mobile number",
    checkoutVerifyOtpSubtitle: "Enter OTP sent to",
    checkoutEditMobile: "Edit",
    checkoutOtpPlaceholder: "Enter OTP",
    checkoutCreateAccountTitle: "Complete your profile",
    checkoutCreateAccountSubtitle: "A few details to finish setting up your account.",
    checkoutCreateAccountButton: "Create account",
    checkoutDeliverTo: "Deliver to",
    checkoutChangeAddress: "Change",
    thankYouTitle: "Order confirmed",
    thankYouDesc: "Thank you! Your payment was successful and your order is confirmed.",
    thankYouOrderNumber: "Order number",
    thankYouOrderId: "Reference",
    thankYouContinueShopping: "Continue shopping",
    thankYouGoToProfile: "Go to profile",
    shipmentPreparing: "Preparing your shipment — tracking will appear shortly",
    shipmentConfirmed: "Order confirmed — preparing shipment",
    shipmentShipped: "Shipped",
    shipmentDelivered: "Delivered",
    shipmentCancelled: "Cancelled or returned",
    shipmentPolling: "Fetching tracking details…",
    shipmentPollingLater: "Tracking is being created. Check your profile or refresh this page in a few minutes.",
    trackingCourier: "Courier",
    trackingAwb: "AWB",
    trackingTrackPackage: "Track package",
    ordersInProgress: "Your orders in progress",
    orderHistory: "Past store orders",
    ordersLoading: "Loading store orders…",
    ordersEmpty: "No store orders yet",
    orderDetailLoading: "Loading order details…",
    orderItemsUnknown: "Store order",
    trackOnCourier: "Track on courier",
    trackingStagePlaced: "Order placed",
    trackingStageProcessing: "Processing",
    trackingStagePacked: "Packed, ready to ship",
    orderStatusPendingPayment: "Payment pending",
    orderStatusPlaced: "Placed — waiting for vendor",
    orderStatusProcessing: "Processing",
    orderStatusPacked: "Packed",
    orderStatusRejected: "Rejected",
  },
  profile: {
    namaste: "Namaste,",
    memberSince: "Member since",
    title: "My Profile",
    subtitle: "Your dashboard and bookings",
    mudrasEarned: "Mudras Earned",
    totalBookings: "Total Bookings",
    mudras: "Mudras",
    dashboard: "Dashboard",
    myBookings: "My Bookings",
    poojaBookingsTab: "Pooja bookings",
    storeOrdersTab: "Store orders",
    myProfile: "My Profile",
    payments: "Payments",
    paymentsSubtitle: "Receipts and amounts for your confirmed bookings",
    paymentsEmpty: "No payment records yet. Confirmed bookings will appear here.",
    paymentsSummaryAria: "Payment summary",
    paymentsTotalSpent: "Total Spent",
    paymentsTransactions: "Transactions",
    paymentsRefunds: "Refunds",
    paymentsTransactionHistory: "Transaction History",
    paymentsColBookingId: "Booking ID",
    paymentsColPooja: "Pooja",
    paymentsColDate: "Date",
    paymentsColMethod: "Method",
    paymentsColAmount: "Amount",
    paymentsColStatus: "Status",
    paymentStatusRefunded: "Refunded",
    paymentStatusCompleted: "Completed",
    paymentStatusConfirmed: "Confirmed",
    paymentStatusCancelled: "Cancelled",
    myJourney: "My Journey",
    myJourneySubtitle: "Your poojas and milestones with Daiv Bharathi",
    myJourneyEmpty: "Your journey begins with your first booking.",
    journeyPoojaTimeline: "Pooja Timeline",
    journeyAchievements: "Achievements & Milestones",
    journeyPriestTba: "Priest to be assigned",
    journeyMilestoneFirst: "First Pooja",
    journeyMilestoneFirstDesc: "Began your sacred journey",
    journeyMilestoneDevotee: "Devotee",
    journeyMilestoneDevoteeDesc: "Completed {n} poojas",
    journeyMilestoneSeeker: "Seeker",
    journeyMilestoneSeekerDesc: "Exploring sacred rituals",
    journeyMilestoneLocked: "Keep participating to unlock",
    wishlist: "Wishlist",
    savedRitualsCount: "{n} saved rituals",
    perBooking: "per booking",
    wishlistEmpty: "No favorites yet. Add poojas from the Upcoming page.",
    trackPoojasLive: "Track poojas live",
    sidebarDownloadSubtitle: "Download the Daiv Bharathi app",
    sidebarAppStore: "App Store",
    sidebarPlayStore: "Google Play",
    sidebarNavAria: "Profile navigation",
    quickActions: "Quick Actions",
    bookPooja: "Book a Pooja",
    consultGuruji: "Consult Guruji",
    panchangToday: "Panchang Today",
    myKundali: "My Kundali",
    inviteFriend: "Invite a Friend",
    upcomingPoojas: "My Recent Booking",
    dashboardUpcomingPoojas: "Upcoming Poojas",
    recentBookings: "Recent Bookings",
    viewAll: "View all",
    upcoming: "Upcoming",
    completed: "Completed",
    watchLive: "Watch Live",
    downloadReceipt: "Download Receipt",
    viewInvoice: "View Invoice",
    logout: "Logout",
    mobile: "Mobile",
    email: "Email",
    gotra: "Gotra",
    city: "City",
    nakshatra: "Nakshatra",
    rashi: "Rashi",
    selectPlaceholder: "Select…",
    dob: "Date of Birth",
    gender: "Gender",
    profilePhoto: "Profile Photo",
    saveProfile: "Save Profile",
    saveChanges: "Save Changes",
    editProfile: "Edit Profile",
    cancel: "Cancel",
    profileSaved: "Profile saved successfully",
    profileError: "Failed to save profile",
    fullName: "Full Name",
    fullNameLettersOnly: "Use letters only (no numbers).",
    emailAddress: "Email Address",
    mobileNumber: "Mobile Number",
    cityLocation: "City / Location",
    dateOfBirth: "Date of Birth",
    languagePreference: "Language Preference",
    reorder: "Reorder",
    sankalpaVideo: "Sankalpa Video",
    myAddresses: "My Address",
    addressesSubtitle: "Save delivery addresses for prasadam and bookings",
    addressesEmpty: "No saved addresses yet. Add one for faster checkout.",
    addressesAddNew: "Add new address",
    addressesAddTitle: "Add address",
    addressesEditTitle: "Edit address",
    addressesLabel: "Label",
    addressesLabelPlaceholder: "e.g. Home, Office, Parents",
    addressesName: "Full name",
    addressesMobile: "Mobile number",
    addressesLine: "Address",
    addressesCity: "City",
    addressesState: "State",
    addressesDistrict: "District",
    addressesPincode: "Pincode",
    addressesSetDefault: "Set as default address",
    addressesDefaultBadge: "Default",
    addressesMakeDefault: "Make default",
    addressesEdit: "Edit",
    addressesDelete: "Delete",
    addressesDeleteConfirm: "Delete this address?",
    addressesSaved: "Address saved successfully",
    addressesUpdated: "Address updated successfully",
    addressesDeleted: "Address deleted successfully",
    addressesDefaultUpdated: "Default address updated",
    addressesLoadError: "Failed to load addresses",
    addressesSaveError: "Failed to save address",
    addressesRequiredError: "Please fill all required fields (label, name, mobile, address, and city)",
    addressesMobileError: "Enter a valid 10-digit mobile number",
    addressesAllRequiredHint: "All fields marked * are required",
    addressesStateDistrictError: "Please select state and district",
    addressesPincodeError: "Please select a pincode",
  },
  orders: {
    title: "My Bookings",
    subtitle: "View your pooja booking details",
    tabAll: "All Bookings",
    tabCompleted: "Completed",
    tabUpcoming: "Upcoming",
    emptyAll: "No bookings yet",
    emptyCompleted: "No completed bookings",
    emptyUpcoming: "No upcoming bookings",
    loading: "Loading your bookings...",
    typePooja: "Pooja bookings",
    typeStore: "Store orders",
  },
  storeOrders: {
    inProgress: "In Progress",
    history: "History",
    emptyProgress: "No orders in progress",
    emptyHistory: "No store orders yet",
    loading: "Loading store orders…",
    detailLoading: "Loading order details…",
    detailError: "Could not load order details",
    deliveryAddress: "Delivery address",
    subtotal: "Subtotal",
    tax: "Tax",
    shipping: "Shipping",
    total: "Total",
    trackPackage: "Track package",
    trackOnShiprocket: "Track on Shiprocket",
    items: "items",
    stagePlaced: "Order placed",
    stageProcessing: "Processing",
    stagePacked: "Packed, ready to ship",
    statusPendingPayment: "Payment pending",
    statusPlaced: "Placed — waiting for vendor",
    statusProcessing: "Processing",
    statusPacked: "Packed",
    statusRejected: "Rejected",
  },
  poojaDetail: {
    yourAcharya: "Your Acharya",
    yourAcharyas: "Your Acharyas",
    verifiedAcharya: "Verified Acharya",
    verifiedAcharyas: "Verified Acharyas",
    acharyaShowMore: "Show more",
    acharyaShowLess: "Show less",
    scrollForMore: "Scroll for more",
    previousPoojaVideo: "Archived Pooja Highlights",
    previousPoojaVideos: "Archived Pooja Highlights",
    previousVideosPlaylistAria: "Archived Pooja Highlights playlist",
    previousVideoPlayAria: "Play archived pooja highlight",
    previousVideoClose: "Close video",
    previousVideoPlayerTitle: "Archived Pooja Highlights video player",
    acharyaYearsVedic: "{n} years of Vedic practice",
    performedBy: "Performed by",
    heroDateLabel: "Pooja date",
    uspLabels: {
      DIVINE_GRACE_DAYS: "Divine grace day",
      TITHI: "Tithi",
      TEMPLE: "Temple",
      KSHETRA: "Kshetra",
    },
    acharyaRitualTrust: "Verified Acharya for this sacred ritual",
    timeLeftUntilLastBooking: "Puja booking will close in :",
    bookingClosesIn: "Booking closes in",
    graceDayEyebrow: "{name} Special",
    trustedByDevotees: "Trusted by 50 Lakh+ Devotees",
    trustedByHint: "Temples · Sevas · Daily devotion",
    trustedByRating: "4.9",
    trustedByRatingAria: "4.9 out of 5 devotee rating",
    trustedByMore: "+50L",
    priceOnwards: "onwards",
    assuranceSankalpa: "Sankalpa in your name",
    assuranceDuration: "{duration} Vedic ritual",
    assurancePrasadam: "Prasadam to your home",
    assurancePrasadamFast: "Prasadam dispatched in 48 Hrs",
    bookSankalpaNow: "Book Sankalpa Now",
    campaignWhatsAppHelp: "Questions about this Pooja? Chat with Priest Advisor",
    campaignWhatsAppPrefill: "Namaste, I have a question about {title}",
    campaignStickyTrust: "{rating}★ · Trusted by 50 Lakh+ Devotees",
    lastHoursTitle: "Last few hours to book",
    finalMinutesTitle: "Final minutes to book",
    closingSoonTitle: "Closing soon",
    timeLeft: "{duration} left",
    closesAtRelative: "Booking closes {day} at {time}",
    openUntil: "Open until {day}, {time}",
    sectionPreparation: "Pooja Preparations",
    prepTitle: "Prepare Yourself for a Divine Experience",
    prepItem1: "Sit in your Pooja Mandir or a serene space for worship.",
    prepItem2: "Place an idol or picture of the deity, if available.",
    prepItem3: "Keep a lamp, flowers, fruits, and sacred offerings ready.",
    prepItem4: "Join a few minutes before the Sankalpa or Pooja begins.",
    prepItem5: "Participate with a peaceful mind and heartfelt devotion.",
    prepNote: "Unable to prepare fully? Simply remember the Divine — sincere devotion is the highest offering.",
    bookingCountdownDayShort: "D",
    bookingCountdownHourShort: "H",
    bookingCountdownMinShort: "M",
    bookingCountdownSecShort: "S",
    bookingCountdownDay: "Day",
    bookingCountdownDays: "Days",
    bookingCountdownHours: "Hours",
    bookingCountdownHour: "Hour",
    bookingCountdownMins: "Mins",
    bookingCountdownMin: "Min",
    bookingCountdownSecs: "Secs",
    bookingCountdownSec: "Sec",
    morePoojas: "More Poojas",
    packages: "Packages",
    acharyas: "Acharyas",
    sectionReviews: "Reviews",
    viewDetails: "View Details",
    backToPoojas: "← Back to Poojas",
    sharePooja: "Share this pooja",
    bookingHeaderActions: "Quick actions",
    breadcrumbNav: "Breadcrumb",
    breadcrumbPoojasHomas: "Poojas & Homas",
    breadcrumbCartAria: "View cart",
    liveStreamsAvailable: "Live streams available",
    next: "Next",
    reviews: "reviews",
    devoteesServed: "devotees served",
    aboutRitual: "About This Ritual",
    aboutPooja: "About this pooja",
    aboutThis: "About This",
    divineBenefits: "Divine Benefits",
    whatsIncluded: "What's Included",
    whyDoThisPooja: "Why should I do this Pooja?",
    templeDetails: "Temple Details",
    howProcessWorks: "How the Process Works",
    processTitle: "Process",
    processLead: "Book with clarity — from package selection to prasadam at your doorstep.",
    processNav: "Process",
    processShowDetails: "Show details",
    processHideDetails: "Hide details",
    processStepBook: "Book",
    processStepSankalpa: "Sankalpa",
    processStepPooja: "Pooja",
    processStepVideo: "Video",
    processStepPrasada: "Prasada",
    processStep: {
      package: {
        title: "Select Package & Add-ons",
        desc: "Choose a package and add-ons as per your requirements.",
      },
      sankalpa: {
        title: "Provide Details",
        desc: "Enter devotee's name and mobile number.",
      },
      offering: {
        title: "Add Offerings",
        desc: "Choose any offerings of your choice in addition to your pooja, if available.",
      },
      payment: {
        title: "Complete Payment",
        desc: "Confirm your Pooja booking by completing the payment.",
      },
      family: {
        title: "Add Sankalpa Details",
        desc: "Add your and the Sankalpa details of other members.",
      },
      updates: {
        title: "Pooja Day Updates",
        desc: "Receive regular updates about the pooja.",
      },
      ritual: {
        title: "Pooja Rituals",
        desc: "An experienced Vedic Acharya will guide you on the rituals.",
      },
      video: {
        title: "Pooja Completion",
        desc: "Receive a video and images of the pooja.",
      },
      prasadam: {
        title: "Prasadam & Add-on Delivery",
        desc: "Sanctified Prasadam & Add-on (if applicable) will be delivered to your doorstep after Pooja completion.",
      },
      compact: {
        packageLine1: "Select Package",
        packageLine2: "& Add-ons",
        sankalpaLine1: "Provide",
        sankalpaLine2: "Details",
        paymentLine1: "Complete",
        paymentLine2: "Payment",
        familyLine1: "Add Sankalpa",
        familyLine2: "Details",
        updatesLine1: "Get Updates",
        updatesLine2: "& Delivery",
      },
    },
    poojaCoordinators: "Pooja coordinators",
    perBooking: "per booking • in your name",
    selectPackage: "SELECT PACKAGE",
    choosePackageTitle: "Choose a package",
    updatePackage: "Change",
    selectedPackage: "Selected package",
    continueWithPackage: "Continue",
    mostPopular: "MOST POPULAR",
    prasadamAvailableNote: "Prasadam delivery available",
    prasadamAvailableWithFee: "Prasadam delivery available · +₹{amount}",
    poojaDate: "POOJA DATE",
    onlySlotsLeft: "Only {n} slots left for {date}",
    limitedSlots: "Limited slots",
    offerEndsIn: "Offer ends in",
    packageTrustTitle: "Why book now",
    packageTrustHurry: "Hurry! Few slots left",
    packageTrustSecure: "Secure & Trusted Booking",
    packageTrustBlessings: "Divine Blessings for You & Your Family",
    viewingNow: "viewing now",
    bookNow: "Book Now",
    freeCancellation: "Free cancellation up to 48 hours before ritual",
    today: "Today",
    megaPoojaBadge: "Mega Pooja",
    megaPoojaScheduleTitle: "Session schedule",
    chatSupport: "Chat support",
    faq: "FAQ",
    participationFees: "Participation Fees",
    advisorCtaLead: "Unsure which ritual to book?",
    advisorCtaTitle: "Our priest advisors are here to help—no obligation.",
    advisorCtaCall: "Call us",
    advisorCtaWhatsApp: "Chat on WhatsApp",
  },
  cart: {
    addToCart: "Add to Cart",
    tab: "Cart",
    pageSubtitle: "Your saved poojas",
    loading: "Loading cart...",
    empty: "Your cart is empty. Add poojas from the Pooja page.",
    emptyBrowse: "Browse Poojas",
    remove: "Remove",
    total: "Total",
    addedToCart: "Added to cart",
    viewCart: "View Cart",
    item: "item",
    items: "items",
  },
  poojaCardActions: {
    favorites: "Favorites",
    addToCart: "Add to Cart",
    share: "Share",
    addedToFavorites: "Added to favorites",
    addedToCart: "Added to cart",
    alreadyInCart: "This pooja is already in your cart",
    pleaseLogIn: "Please log in to add to cart",
  },
  consent: {
    bannerLead: "We use cookies to enhance your experience and provide better pooja services.",
    bannerLeadShort: "Cookies help us improve your pooja experience.",
    bannerSub: "You can accept all cookies for a smoother journey or continue with essential cookies only.",
    privacyNote: "Read our ",
    accept: "Accept All",
    acceptShort: "Accept",
    reject: "Only Required",
    rejectShort: "Essential",
    privacyLink: "Privacy Policy",
  },
  mobileApp: {
    takeDharmaEyebrow: "Take Dharma Everywhere You Go",
    downloadEyebrow: "Download Free",
    downloadTitle1: "Take dharma",
    downloadTitle2: "everywhere you go",
    downloadDesc:
      "Book sacred poojas, ask Guruji, receive daily panchang, and play devotionals from the palm of your hand. Free to download. Free to start.",
    storeAppleAlt: "Download on the App Store",
    storeGoogleAlt: "Get it on Google Play",
    trustFree: "Free to download",
    trustPlatforms: "Available on Android and iOS",
    trustLanguages: "Eight Indian languages",
    trustNoSpam: "No spam, ever",
    downloadLanguagesNote: "English, Hindi, Kannada, Tamil, Telugu, Bengali, Marathi, Gujarati.",
    downloadSectionAria: "Download the Daiv Bharathi app",
    heroAria: "Mobile App Hero",
    heroEyebrow: "THE DAIV BHARATHI APP",
    heroTitle: "One app for temples, Guruji, and daily devotion.",
    heroTitle1: "One app for",
    heroTitle2: "temples, Guruji,",
    heroTitle3: "and daily devotion.",
    heroTitleLead: "One app for",
    heroTitleMid: "temples, Guruji,",
    heroTitleEnd: "and daily devotion.",
    heroSubtitle:
      "Book sevas, talk to Guruji, follow panchang, and stay with mantras, clips, and community — on Android and iOS.",
    heroHelper: "Free to download. Sign in with your mobile number. Available in eight Indian languages.",
    heroStatsAria: "App highlights",
    statActiveDevotees: "Active Devotees",
    statDevoteeRating: "Devotee Rating",
    statRitualsPerformed: "Rituals Performed",
    statSacredKshetras: "Sacred Kshetras",
    statsBandAria: "Community highlights",
    ecosystemTitle: "Everything you need, all in one place",
    ecosystemSubtitle: "Four spaces in the app — one connected experience for devotees across India and the world.",
    moduleHomeName: "Home",
    moduleHomeDesc: "Ask Guruji, book poojas, clips, and your Daiv Mandir",
    moduleFaithName: "Faith",
    moduleFaithDesc: "Temple sevas and certified purohits",
    moduleAstroName: "Astro",
    moduleAstroDesc: "Daily panchang, your Guruji, and plans",
    moduleMediaName: "Media",
    moduleMediaDesc: "Bhajans, videos, clips, and community",
    sacredAccessAria: "Sacred Access",
    sacredAccessEyebrow: "Sacred Access",
    sacredAccessHeadline1: "Discover temples.",
    sacredAccessHeadline2: "Book sevas.",
    sacredAccessHeadline3: "Stay connected.",
    sacredAccessLead:
      "Daiv Bharathi makes temple access more structured and more accessible — helping you discover temples, explore their offerings, participate in sevas, and stay connected to sacred spaces beyond physical distance.",
    sacredAccessFeat1Title: "Daiv Mandir",
    sacredAccessFeat1Body: "Explore temples, their deities, and ritual significance in one organised space.",
    sacredAccessFeat2Title: "Sevas",
    sacredAccessFeat2Body:
      "View temple-specific sevas and offerings with clarity on timing, cost, and outcome. Book through a smooth, trusted digital experience.",
    sacredAccessFeat3Title: "Purohit",
    sacredAccessFeat3Body: "Connect with certified purohits for ceremonies, homas, and ritual support.",
    whyItMatters: "Why It Matters",
    sacredAccessWhyText:
      "2,00,000+ devotees access temples and book sevas without travelling. Spiritual access — democratised.",
    guidedInsightAria: "Guided Insight",
    guidedInsightEyebrow: "Guided Insight",
    guidedInsightHeadline1: "Personalised guidance",
    guidedInsightHeadline2: "for everyday",
    guidedInsightHeadline3: "spiritual life",
    guidedInsightLead:
      "Not every spiritual need begins at a temple. Many begin with a question, a concern, or a search for clarity. Ask Guruji, read panchang, and find direction that feels relevant to your life.",
    guidedInsightFeat1Title: "Ask Guruji",
    guidedInsightFeat1Body: "Chat with your assigned Guruji from Home. Share birth details once; receive guidance after that.",
    guidedInsightFeat2Title: "Daily Panchang",
    guidedInsightFeat2Body: "Start every day grounded — Tithi, Nakshatra, Yoga, Rahu Kaal, and auspicious Muhurat.",
    guidedInsightFeat3Title: "Horoscope",
    guidedInsightFeat3Body: "Zodiac predictions in the Astro tab — daily, weekly, and monthly.",
    guidedInsightFeat4Title: "Plans",
    guidedInsightFeat4Body: "Free to start. Upgrade when you need more time with Guruji.",
    guidedInsightWhyText:
      "Personalised guidance built on Vedic principles, not generic horoscopes. Direction that feels relevant to your life.",
    spiritualDiscoveryAria: "Spiritual Discovery",
    spiritualDiscoveryEyebrow: "Spiritual Discovery",
    spiritualDiscoveryHeadline1: "A richer way to",
    spiritualDiscoveryHeadline2: "learn, explore,",
    spiritualDiscoveryHeadline3: "and stay engaged",
    spiritualDiscoveryLead:
      "Daiv Bharathi is not only about bookings. It creates space for spiritual discovery through music, clips, and community — so you stay connected beyond festival days.",
    spiritualDiscoveryFeat1Title: "Library",
    spiritualDiscoveryFeat1Body: "Bhajans, videos, and podcasts to deepen your practice.",
    spiritualDiscoveryFeat2Title: "Clips",
    spiritualDiscoveryFeat2Body: "Short devotional videos you can watch and share.",
    spiritualDiscoveryFeat3Title: "Community",
    spiritualDiscoveryFeat3Body: "Channels and devotee spaces to stay with others on the path.",
    spiritualDiscoveryFeat4Title: "Mantra",
    spiritualDiscoveryFeat4Body: "Count and practise mantras from the app.",
    spiritualDiscoveryWhyText:
      "Stay spiritually engaged every day, not just on festival days. A living connection to your dharmic roots.",
    seoTitle: "Daiv Bharathi Mobile App | Temples, Guruji, Panchang & Sevas",
    seoDescription:
      "Download the Daiv Bharathi app for Android and iOS. Book temple sevas, talk to Guruji, follow daily panchang, and stay with bhajans, clips, and community.",
  },
  temple: {
    heroTitle: "Sacred Kshetras Across India",
    heroDesc: "We connect you through our verified spiritual network across India",
    seoDescription: "Sacred Kshetras across India — we connect you through our verified spiritual network. Daiv Bharathi.",
    searchPlaceholder: "Search temples by deity, location, or name...",
    byDeity: "By Deity",
    byState: "By State",
    all: "All",
    viewPoojas: "View Poojas",
    poojasLabel: "Poojas",
    noTemples: "No temples found",
  },
  states: {
    "Andhra Pradesh": "Andhra Pradesh",
    "Arunachal Pradesh": "Arunachal Pradesh",
    Assam: "Assam",
    Bihar: "Bihar",
    Chhattisgarh: "Chhattisgarh",
    Goa: "Goa",
    Gujarat: "Gujarat",
    Haryana: "Haryana",
    "Himachal Pradesh": "Himachal Pradesh",
    Jharkhand: "Jharkhand",
    Karnataka: "Karnataka",
    Kerala: "Kerala",
    "Madhya Pradesh": "Madhya Pradesh",
    Maharashtra: "Maharashtra",
    Manipur: "Manipur",
    Meghalaya: "Meghalaya",
    Mizoram: "Mizoram",
    Nagaland: "Nagaland",
    Odisha: "Odisha",
    Punjab: "Punjab",
    Rajasthan: "Rajasthan",
    Sikkim: "Sikkim",
    "Tamil Nadu": "Tamil Nadu",
    Telangana: "Telangana",
    Tripura: "Tripura",
    "Uttar Pradesh": "Uttar Pradesh",
    Uttarakhand: "Uttarakhand",
    "West Bengal": "West Bengal",
    "Andaman & Nicobar": "Andaman & Nicobar",
    Chandigarh: "Chandigarh",
    "Dadra & Nagar Haveli": "Dadra & Nagar Haveli",
    Delhi: "Delhi",
    "Jammu and Kashmir": "Jammu and Kashmir",
    Ladakh: "Ladakh",
    Lakshadweep: "Lakshadweep",
    Puducherry: "Puducherry",
  },
  common: {
    ok: "OK",
    close: "Close",
    back: "← Back",
    viewDetails: "View Details",
    loading: "Loading…",
    error: "Failed to load poojas",
  },
};

export default en;
